import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private api: ApiService) {}

  login(body) {
    return this.api.post(
      `${environment.api.baseurl}${environment.api.login}`,
      body
    );
  }

  register(body) {
    return this.api.post(
      `${environment.api.baseurl}${environment.api.registerUser}`,
      body
    );
  }

  fetchUserInfo(){
    return this.api.get(
      `${environment.api.baseurl}${environment.api.fetchUserInfo}`
    );
  }

  getRegisterDetails() {
    return this.api.get(
      `${environment.api.baseurl}${environment.api.getRegisterDetails}`
    );
  }

  verifyActivationToken(token) {
    return this.api.get(
      `${environment.api.baseurl}${environment.api.verifyActivationToken}/${token}`
    );
  }

  activatePassword(password, token) {
    return this.api.post(
      `${environment.api.baseurl}${environment.api.verifyActivationToken}/${token}`,
      { validProbData: true, confirmPassword: password, password: password }
    );
  }

  verifyResetToken(token) {
    return this.api.get(
      `${environment.api.baseurl}${environment.api.verifyResetToken}/${token}`
    );
  }

  resetPassword(password, token) {
    return this.api.post(
      `${environment.api.baseurl}${environment.api.verifyResetToken}/${token}`,
      { validProbData: true, confirmPassword: password, password: password }
    );
  }

  forgotPassword(email) {
    return this.api.post(
      `${environment.api.baseurl}${environment.api.forgotPassword}`,
      { userEmail: email }
    );
  }

  changePassword(password) {
    let temp = { ...password };
    temp.validProbData = true;
    return this.api.post(
      `${environment.api.baseurl}${environment.api.changePassword}`,
      temp
    );
  }
}
